import axios from "axios";

export default {
  namespaced: true,
  state: {
    funds: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    fundsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_INVESTFUNDS(state, payload) {
      state.funds = payload;
      state.isReceiving = false;
    },
    RECEIVING_INVESTFUNDS(state) {
      state.isReceiving = true;
    },
    RECEIVED_INVESTFUND(state, payload) {
      let find = state.funds.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { funds: [payload, ...state.funds] });
      }
      else {
        let index = state.funds.findIndex(x => x._id === payload._id);
        state.funds.splice(index, 1, payload);
      }
    },
    RECEIVING_INVESTFUND(state) {
      state.isReceiving = true;
    },
    UPDATED_INVESTFUND(state, payload) {
      let index = state.funds.findIndex(investfund => investfund._id === payload._id);
      state = Object.assign(state, {
        funds: state.funds.map((investfund, i) => {
          if (i === index) {
            return Object.assign({}, investfund, payload);
          }
          return investfund;
        }),
        isUpdating: false,
        fundsMessage: 'InvestFunds has been updating!',
      })
    },
    UPDATING_INVESTFUND(state) {
      state.isUpdating = true;
    },
    DELETED_INVESTFUND(state, payload) {
      let indexToDelete = state.funds.findIndex(investfund => investfund._id === payload._id);
      let funds = [...state.funds];
      funds.splice(indexToDelete, 1);
      state = Object.assign(state, {
        funds: [...funds],
        isDeleting: false,
        idToDelete: null,
        fundsMessage: 'InvestFund has been Deleted!',
      });
    },
    DELETING_INVESTFUND(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getInvestFundsRequest({dispatch}) {
      dispatch("receivingInvestFunds");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.accountxc.com:3100/get/investfunds';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(response => {
        dispatch("receiveInvestFunds", response.data);
      })
    },
    async getInvestFundRequest({dispatch}, id) {
      dispatch("receivingInvestFunds");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/investfund/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveInvestFund", response.data);
      })
    },
    async updateInvestFundRequest({dispatch}, payload) {
      dispatch("updatingInvestFund");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/investfund/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (response) {
        dispatch("updateInvestFund", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateInvestFundImageRequest({dispatch}, payload) {
      dispatch("updatingInvestFund");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/investfund/image/' + id;
      let data = new FormData();
      data.append('image', payload.investfundimage, payload.imagename); 
      delete payload['investfundimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateInvestFund", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertInvestFundRequest({dispatch}, payload) {
      dispatch("receivingInvestFund");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/investfund';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveInvestFund", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async insertInvestFundWithImageRequest({dispatch}, payload) {
      dispatch("receivingInvestFund");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/investfund/withimage';
      let data = new FormData();
      data.append('image', payload.investfundimage, payload.imagename); 
      delete payload['investfundimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveInvestFund", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteInvestFundRequest({dispatch}, payload) {
      dispatch("deletingInvestFund", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/investfund/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteInvestFund", {_id: payload._id});
      })
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveInvestFunds({commit}, payload) {
      commit("RECEIVED_INVESTFUNDS", payload)
    },
    receivingInvestFunds({commit}) {
      commit("RECEIVING_INVESTFUNDS")
    },
    receiveInvestFund({commit}, payload) {
      commit("RECEIVED_INVESTFUND", payload)
    },
    receivingInvestFund({commit}) {
      commit("RECEIVING_INVESTFUND")
    },
    updateInvestFund({commit}, payload) {
      commit("UPDATED_INVESTFUND", payload)
    },
    updatingInvestFund({commit}) {
      commit("UPDATING_INVESTFUND")
    },
    deleteInvestFund({commit}, payload) {
      commit("DELETED_INVESTFUND", payload)
    },
    deletingInvestFund({commit}, payload) {
      commit("DELETING_INVESTFUND", payload)
    }
  },
};
